// src/data/equipmentData.js

const foodData = [
{ id: 58, name: "", image: "/images/coverpic.jpg" },
{ id: 58, name: "", image: "/images/IMG-20250930-WA0043.jpg" },
{ id: 80, name: "", image: "/images/IMG-iwb1.jpg" },

  { id: 34, name: "", image: "/images/IMG-iwb1.jpg" },

{ id: 51, name: "", image: "/images/IMG-iwb2.jpg" },
{ id: 52, name: "", image: "/images/IMG-iwb3.jpg" },
{ id: 53, name: "", image: "/images/IMG-iwb4.jpg" },
{ id: 54, name: "", image: "/images/IMG-iwb5.jpg" },
{ id: 55, name: "", image: "/images/IMG-iwb6.jpg" },
 
];

export default foodData;


